module.exports = __webpack_public_path__ + "static/firefox-7c7ea1548fc727f1e1afb950834614df.png";